import type { Land } from '@trace/shared/types';

export const mockLands: Land[] = [
  {
    id: 'land_01',
    tenantId: 'tenant_wuchang_001',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    enterpriseId: 8001,
    enterpriseName: '五常市龙凤山水稻专业种植示范合作社',
    code: 'LAND-2026-A01',
    name: '五常核心有机基地 · 1号稻田A区',
    area: 120,
    manager: '李春山',
    contactPhone: '13900139001',
    address: '黑龙江省哈尔滨市五常市安家镇有机生态种植示范区A区',
    soilType: '典型弱碱性草甸黑钙土 (有机质含量 4.2%)',
    waterSource: '拉林河源头天然自流活水灌溉',
    varieties: ['五优稻4号 (稻花香2号)'],
    status: 'active',
    boundary: {
      center: { lng: 127.1524, lat: 44.9281 },
      points: [
        { lng: 127.1501, lat: 44.9265 },
        { lng: 127.1552, lat: 44.9272 },
        { lng: 127.1548, lat: 44.9301 },
        { lng: 127.1498, lat: 44.9295 },
      ],
    },
    // 土壤检测报告
    soilReportUrl: 'ledgers/env/LAND-2026-A01_五常1号田黑土508项环境质量检测报告.pdf',
    soilReportName: '五常1号田黑土508项环境质量检测报告.pdf',
    soilReportDate: '2026-05-18',
    soilReportAgency: '农业农村部谷物品质监督检验测试中心 (CMA/CNAS)',
    soilReportResult: '⭐ 优级有机黑土 (有机质4.2% / 未检出重金属与农残)',
    soilReportSize: 3480000,
    // 灌溉水检测报告
    waterReportUrl: 'ledgers/env/LAND-2026-A01_拉林河源头灌溉水质50项检测报告.pdf',
    waterReportName: '拉林河源头灌溉水质50项检测报告.pdf',
    waterReportDate: '2026-05-20',
    waterReportAgency: '国家环境监测总站松花江监测中心 (CMA)',
    waterReportResult: '⭐ Ⅰ类优质地表自流活水 (符合 GB 5084 有机标准)',
    waterReportSize: 2860000,
    certificates: [
      {
        id: 'cert_01',
        certNumber: '100OP2200185',
        certName: '国家有机产品认证证书 (GB/T 19630)',
        issuer: '北京爱科赛尔认证中心',
        issueDate: '2025-09-01T00:00:00Z',
        expiryDate: '2026-08-31T00:00:00Z',
        status: 'valid',
        fileUrl: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=600&auto=format&fit=crop&q=80',
        fileType: 'image',
        landId: 'land_01',
        landName: '五常核心有机基地 · 1号稻田A区',
        landCode: 'LAND-2026-A01',
        scope: '有机水稻种植 · 120亩',
        createdAt: '2025-09-01T00:00:00Z',
        updatedAt: '2026-01-01T00:00:00Z',
      },
    ],
    lastSyncTime: '2026-08-26T08:30:00Z',
    syncStatus: 'synced',
    remarks: '国家首批有机水稻种植标准化示范基地',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-26T08:30:00Z',
  },
  {
    id: 'land_02',
    tenantId: 'tenant_wuchang_001',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    enterpriseId: 8001,
    enterpriseName: '五常市龙凤山水稻专业种植示范合作社',
    code: 'LAND-2026-A02',
    name: '五常核心有机基地 · 2号稻田B区',
    area: 150,
    manager: '张建军',
    contactPhone: '13900139002',
    address: '黑龙江省哈尔滨市五常市安家镇有机生态种植示范区B区',
    soilType: '深层黑土 (有机质含量 4.5%)',
    waterSource: '磨盘山水库直供弱碱泉水',
    varieties: ['龙稻18 (优质长粒香)'],
    status: 'active',
    boundary: {
      center: { lng: 127.1585, lat: 44.9298 },
      points: [
        { lng: 127.1558, lat: 44.9280 },
        { lng: 127.1615, lat: 44.9288 },
        { lng: 127.1608, lat: 44.9318 },
        { lng: 127.1552, lat: 44.9310 },
      ],
    },
    // 土壤检测报告
    soilReportUrl: 'ledgers/env/LAND-2026-A02_五常2号田深层黑土全项检测报告.pdf',
    soilReportName: '五常2号田深层黑土全项检测报告.pdf',
    soilReportDate: '2026-05-18',
    soilReportAgency: '黑龙江省农业科学院农业环境与资源研究所 (CMA)',
    soilReportResult: '⭐ 优级有机黑土 (有机质4.5% / 弱碱性土壤)',
    soilReportSize: 3120000,
    // 灌溉水检测报告
    waterReportUrl: 'ledgers/env/LAND-2026-A02_磨盘山天然泉水水质检测报告.pdf',
    waterReportName: '磨盘山天然泉水水质检测报告.pdf',
    waterReportDate: '2026-05-20',
    waterReportAgency: '谱尼测试集团 (PONY CMA/CNAS)',
    waterReportResult: '⭐ Ⅰ类优质弱碱天然泉水 (pH 7.4 / 符合有机标准)',
    waterReportSize: 2650000,
    certificates: [
      {
        id: 'cert_02',
        certNumber: '100OP2200186',
        certName: '中国有机水稻认证证书',
        issuer: '中绿华夏有机产品认证中心',
        issueDate: '2025-09-15T00:00:00Z',
        expiryDate: '2026-09-14T00:00:00Z',
        status: 'valid',
        fileUrl: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600&auto=format&fit=crop&q=80',
        fileType: 'image',
        landId: 'land_02',
        landName: '五常核心有机基地 · 2号稻田B区',
        landCode: 'LAND-2026-A02',
        scope: '有机水稻种植 · 150亩',
        createdAt: '2025-09-15T00:00:00Z',
        updatedAt: '2026-01-01T00:00:00Z',
      },
    ],
    lastSyncTime: '2026-08-26T08:30:00Z',
    syncStatus: 'synced',
    remarks: '绿色防控太阳能杀虫灯全覆盖',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-26T08:30:00Z',
  },
  {
    id: 'land_03',
    tenantId: 'tenant_wuchang_001',
    baseId: 3002,
    baseName: '嫩江流域高寒富硒有机黑米种植示范基地',
    enterpriseId: 8002,
    enterpriseName: '嫩江市金穗生态农业深加工有限责任公司',
    code: 'LAND-2026-B01',
    name: '嫩江平原有机基地 · 3号试验田',
    area: 90,
    manager: '王志强',
    contactPhone: '13900139003',
    address: '黑龙江省齐齐哈尔市泰来县嫩江沿岸有机水稻种植区',
    soilType: '富硒黑钙土 (有机质 3.8%)',
    waterSource: '嫩江干流水质Ⅰ类活水',
    varieties: ['绥粳18 (高胚芽留存率优选品种)'],
    status: 'active',
    boundary: {
      center: { lng: 127.1462, lat: 44.9250 },
      points: [
        { lng: 127.1435, lat: 44.9235 },
        { lng: 127.1490, lat: 44.9242 },
        { lng: 127.1482, lat: 44.9268 },
        { lng: 127.1428, lat: 44.9260 },
      ],
    },
    // 土壤检测报告
    soilReportUrl: 'ledgers/env/LAND-2026-B01_嫩江富硒黑钙土全项检测报告.pdf',
    soilReportName: '嫩江富硒黑钙土全项检测报告.pdf',
    soilReportDate: '2026-05-15',
    soilReportAgency: '农业农村部谷物品质监督检验测试中心',
    soilReportResult: '⭐ 富硒有机黑土 (天然硒含量 0.35mg/kg 达标)',
    soilReportSize: 2980000,
    // 灌溉水检测报告
    waterReportUrl: 'ledgers/env/LAND-2026-B01_嫩江干流农田灌溉水质检测报告.pdf',
    waterReportName: '嫩江干流农田灌溉水质检测报告.pdf',
    waterReportDate: '2026-05-17',
    waterReportAgency: '黑龙江省水环境监测中心',
    waterReportResult: '⭐ Ⅰ类地表自流活水 (符合 GB 5084 标准)',
    waterReportSize: 2450000,
    certificates: [
      {
        id: 'cert_03',
        certNumber: '100OP2200199',
        certName: '欧盟及中国双重有机认证',
        issuer: '南京国环有机产品认证中心 (OFDC)',
        issueDate: '2025-08-28T00:00:00Z',
        expiryDate: '2026-08-27T00:00:00Z',
        status: 'expiring_soon',
        fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&auto=format&fit=crop&q=80',
        fileType: 'image',
        landId: 'land_03',
        landName: '嫩江平原有机基地 · 3号试验田',
        landCode: 'LAND-2026-B01',
        scope: '有机富硒水稻 · 90亩',
        createdAt: '2025-08-28T00:00:00Z',
        updatedAt: '2026-01-01T00:00:00Z',
      },
    ],
    lastSyncTime: '2026-08-26T08:15:00Z',
    syncStatus: 'synced',
    remarks: '富硒胚芽米专属培育地块',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-26T08:15:00Z',
  },
  {
    id: 'land_04',
    tenantId: 'tenant_wuchang_001',
    baseId: 3002,
    baseName: '嫩江流域高寒富硒有机黑米种植示范基地',
    enterpriseId: 8002,
    enterpriseName: '嫩江市金穗生态农业深加工有限责任公司',
    code: 'LAND-2026-B02',
    name: '嫩江平原有机基地 · 4号轮作休耕田',
    area: 80,
    manager: '王志强',
    contactPhone: '13900139003',
    address: '黑龙江省齐齐哈尔市泰来县嫩江沿岸有机水稻种植区',
    soilType: '草甸黑钙土',
    waterSource: '嫩江干流水系',
    varieties: ['绿肥紫云英 (土壤轮作培肥)'],
    status: 'fallow',
    boundary: {
      center: { lng: 127.1650, lat: 44.9330 },
      points: [
        { lng: 127.1620, lat: 44.9315 },
        { lng: 127.1678, lat: 44.9322 },
        { lng: 127.1672, lat: 44.9348 },
        { lng: 127.1615, lat: 44.9340 },
      ],
    },
    certificates: [],
    lastSyncTime: '2026-08-25T12:00:00Z',
    syncStatus: 'synced',
    remarks: '有机轮作休耕中，2027年春季复播',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-25T12:00:00Z',
  },
];

export const mockOrganicLedgers: any[] = [
  {
    id: 'ledger_01',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    ledgerName: '2026年度五常1号田全周期农事与田间管理台账',
    ledgerCode: 'LEDGER-2026-A01-001',
    ledgerType: 'farming',
    recordDate: '2026-08-20',
    periodStart: '2026-04-10',
    periodEnd: '2026-08-20',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260820/ledger_a01_001.pdf',
    fileName: '五常1号田全周期农事操作合规台账.pdf',
    fileSizeBytes: 3670016,
    fileType: 'pdf',
    operator: '李春山',
    auditor: '张建华',
    auditStatus: 'compliant',
    organicStandard: 'GB/T 19630-2019',
    remarks: '涵盖浸种催芽、北斗无人插秧、稻鸭共育及联合收割全流程农事记录',
    createdAt: '2026-08-20T10:00:00Z',
    updatedAt: '2026-08-20T10:00:00Z',
  },
  {
    id: 'ledger_02',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    ledgerName: '1号田有机允许投入品与生物制剂施用明细台账',
    ledgerCode: 'LEDGER-2026-A01-002',
    ledgerType: 'input_usage',
    recordDate: '2026-07-15',
    periodStart: '2026-04-15',
    periodEnd: '2026-07-15',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260715/ledger_a01_002.pdf',
    fileName: '1号田投入品采购与施用台账.pdf',
    fileSizeBytes: 1845200,
    fileType: 'pdf',
    operator: '张建华',
    auditor: '李春山',
    auditStatus: 'compliant',
    organicStandard: 'GB/T 19630-2019',
    remarks: '纯发酵羊粪生物有机肥与印楝素施用量核对无误，符合有机规范',
    createdAt: '2026-07-15T15:30:00Z',
    updatedAt: '2026-07-15T15:30:00Z',
  },
  {
    id: 'ledger_03',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    ledgerName: '五常龙凤山核心区灌溉水质与土壤环境监测台账',
    ledgerCode: 'LEDGER-2026-A01-003',
    ledgerType: 'env_monitor',
    recordDate: '2026-06-30',
    periodStart: '2026-01-01',
    periodEnd: '2026-06-30',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260630/ledger_a01_003.pdf',
    fileName: '2026上半年五常水土生态监测汇编.pdf',
    fileSizeBytes: 5242880,
    fileType: 'pdf',
    operator: '张晓东',
    auditor: '张建华',
    auditStatus: 'compliant',
    organicStandard: 'GB 15618-2018 / GB 5084-2021',
    remarks: '土壤有机质4.86g/kg，灌溉水I类地表水质检测合格',
    createdAt: '2026-06-30T17:00:00Z',
    updatedAt: '2026-06-30T17:00:00Z',
  },
  {
    id: 'ledger_04',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    landId: 'land_02',
    landName: '五常核心有机基地 · 2号稻田B区',
    landCode: 'LAND-2026-A02',
    ledgerName: '2026年2号稻田B区秋季原粮理论测产与收获台账',
    ledgerCode: 'LEDGER-2026-A02-001',
    ledgerType: 'harvest',
    recordDate: '2026-08-22',
    periodStart: '2026-08-20',
    periodEnd: '2026-08-22',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260822/ledger_a02_001.pdf',
    fileName: '2号稻田B区实测产量与水分杂质检验单.pdf',
    fileSizeBytes: 1420000,
    fileType: 'pdf',
    operator: '李春山',
    auditor: '李宏',
    auditStatus: 'compliant',
    organicStandard: 'GB/T 19630-2019',
    remarks: '实收稻谷95,000kg，水分14.0%，杂质0.7%，特级原粮入库',
    createdAt: '2026-08-22T16:00:00Z',
    updatedAt: '2026-08-22T16:00:00Z',
  },
  {
    id: 'ledger_05',
    baseId: 3002,
    baseName: '嫩江流域高寒富硒有机黑米种植示范基地',
    landId: 'land_03',
    landName: '嫩江高寒富硒基地 · 黑珍珠1号田',
    landCode: 'LAND-2026-B01',
    ledgerName: '嫩江富硒黑米基地有机生产综合内审自查台账',
    ledgerCode: 'LEDGER-2026-N01-001',
    ledgerType: 'organic_audit',
    recordDate: '2026-08-10',
    periodStart: '2026-05-01',
    periodEnd: '2026-08-10',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260810/ledger_n01_001.pdf',
    fileName: '嫩江基地2026年度有机认证内审台账.pdf',
    fileSizeBytes: 4194304,
    fileType: 'pdf',
    operator: '王建国',
    auditor: '张建华',
    auditStatus: 'compliant',
    organicStandard: 'EU Organic / GB/T 19630',
    remarks: '高寒天然富硒黑土地块管理合规性自查，现场记录完整',
    createdAt: '2026-08-10T14:20:00Z',
    updatedAt: '2026-08-10T14:20:00Z',
  },
  {
    id: 'ledger_06',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    ledgerName: '五常核心基地有机水稻原种纯度与非转基因追溯台账',
    ledgerCode: 'LEDGER-2026-A01-004',
    ledgerType: 'seed_sourcing',
    recordDate: '2026-04-12',
    periodStart: '2026-03-01',
    periodEnd: '2026-04-12',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260412/ledger_a01_004.pdf',
    fileName: '五优稻4号种子来源与发芽率检验台账.pdf',
    fileSizeBytes: 980000,
    fileType: 'pdf',
    operator: '李春山',
    auditor: '张建华',
    auditStatus: 'compliant',
    organicStandard: 'GB 4404.1-2020',
    remarks: '五优稻4号原种留胚率88.5%，无化学包衣杀菌剂处理',
    createdAt: '2026-04-12T11:00:00Z',
    updatedAt: '2026-04-12T11:00:00Z',
  },
  {
    id: 'ledger_07',
    baseId: 3001,
    baseName: '五常市龙凤山水源地国家级有机水稻种植示范基地',
    landId: 'land_02',
    landName: '五常核心有机基地 · 2号稻田B区',
    landCode: 'LAND-2026-A02',
    ledgerName: '2号田龙凤山活水灌排与水质日常巡检记录表',
    ledgerCode: 'LEDGER-2026-A02-002',
    ledgerType: 'env_monitor',
    recordDate: '2026-07-28',
    periodStart: '2026-05-01',
    periodEnd: '2026-07-28',
    fileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    objectName: 'ledgers/20260728/ledger_a02_002.pdf',
    fileName: '2号田活水灌溉巡田台账.pdf',
    fileSizeBytes: 1250000,
    fileType: 'pdf',
    operator: '李春山',
    auditor: '李宏',
    auditStatus: 'compliant',
    organicStandard: 'GB 5084-2021',
    remarks: '水层保持3-5cm，水温适宜分蘖生长',
    createdAt: '2026-07-28T09:30:00Z',
    updatedAt: '2026-07-28T09:30:00Z',
  },
];

